var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function (ref) {
              var on = ref.on
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    {
                      class: _vm.cssClasses,
                      attrs: {
                        fab: "",
                        "aria-label": _vm.btnAriaLabel,
                        small: _vm.small,
                        large: _vm.large,
                        loading: _vm.showLoading,
                        color: _vm.contentControlItem.color,
                        dark: _vm.dark,
                        light: _vm.light,
                        to: _vm.contentControlItem.to,
                        href: _vm.contentControlItem.href,
                        target: _vm.contentControlItem.target,
                      },
                      on: { click: _vm.clickHandler },
                    },
                    on
                  ),
                  [
                    _c(
                      "v-icon",
                      { attrs: { dark: _vm.dark, light: _vm.light } },
                      [_vm._v(_vm._s(_vm.contentControlItem.icon))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.btnTooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }